import React from 'react';
import PropTypes from 'prop-types';

export default class PreviewLink extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      previewLinkURL: props.previewLinkState.previewLinkURL,
      liveLinkURL: props.previewLinkState.liveLinkURL,
      itemId: props.previewLinkState.itemId,
    };
  }

  render() {
    const { previewLinkURL, liveLinkURL, itemId } = this.state;
    const previewLinkHREF = previewLinkURL.replace(':id', itemId);
    const liveLinkHREF = liveLinkURL.replace(':id', itemId);

    return (
      <div className="preview-links">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={previewLinkHREF}
          className="preview-link__link"
        >
          View Preview
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={liveLinkHREF}
          className="preview-link__link"
        >
          View Live
        </a>
      </div>
    );
  }
}

PreviewLink.propTypes = {
  previewLinkState: PropTypes.shape({
    previewLinkURL: PropTypes.string.isRequired,
    liveLinkURL: PropTypes.string.isRequired,
    itemId: PropTypes.string.isRequired,
  }).isRequired,
};
